import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';



export default function DGLTH_customer_order_delivery({ item, props, entity = null, refreshData }) {

    const navigate = useNavigate()

    function ddtCustomerOrder(item) {
        navigate('/page/CustomerDdtPreview?id=' + item.id)
    }

    async function delivered() {
        console.log('ITEM', item)
        try {
            const deliveryRowsResponse = await DataManager.getItem('customer_order_delivery', item.id)
            if (deliveryRowsResponse.success !== 1 || !deliveryRowsResponse.body || deliveryRowsResponse.body.length === 0) {
                throw new Error(deliveryRowsResponse.message || 'Impossibile recuperare le righe della consegna.')
            }

            const deliveryRows = Array.isArray(deliveryRowsResponse.body[0].rows) ? deliveryRowsResponse.body[0].rows : []

            if (deliveryRows.length) {
                for (let i = 0; i < deliveryRows.length; i++) {
                    const deliveryRow = deliveryRows[i]
                    const deliveryRowId = deliveryRow && deliveryRow.id
                    if (deliveryRowId) {
                        const deliveryRowUpdate = await DataManager.updateItem('customer_order_delivery_row', { status: { value: "10_DELIVERED", label: "10_DELIVERED" } }, deliveryRowId)
                        if (deliveryRowUpdate.success !== 1) {
                            throw new Error(deliveryRowUpdate.message || 'Impossibile aggiornare la riga della consegna.')
                        }
                    }

                    let orderRowId = null
                    if (deliveryRow && deliveryRow.idCustomerOrderRow !== undefined && deliveryRow.idCustomerOrderRow !== null) {
                        if (typeof deliveryRow.idCustomerOrderRow === 'object') {
                            orderRowId = deliveryRow.idCustomerOrderRow.id
                        }
                        else {
                            orderRowId = deliveryRow.idCustomerOrderRow
                        }
                    }
                    if (orderRowId) {
                        const orderRowUpdate = await DataManager.updateItem('customer_order_row', { status: { value: "20_DELIVERED", label: "20_DELIVERED" } }, orderRowId)
                        if (orderRowUpdate.success !== 1) {
                            throw new Error(orderRowUpdate.message || 'Impossibile aggiornare la riga dell\'ordine cliente.')
                        }
                    }
                }
            }

            const deliveryStatus = { status: { value: "20_DELIVERED", label: "20_DELIVERED" } }
            const updateDelivery = await DataManager.updateItem(entity, deliveryStatus, item.id)
            if (updateDelivery.success !== 1) {
                Swal.fire({ title: 'Errore', text: updateDelivery.message || 'Impossibile aggiornare la consegna.', icon: 'error', confirmButtonColor: '#dc3545' })
                return
            }

            const orderId = item?.idCustomerOrder?.id || item?.idCustomerOrder
            if (orderId) {
                const orderResponse = await DataManager.getItem('customer_order', orderId)
                if (orderResponse.success === 1 && orderResponse.body && orderResponse.body.length > 0) {
                    const customerOrder = orderResponse.body[0]
                    const orderRows = Array.isArray(customerOrder.rows) ? customerOrder.rows : []
                    const allDelivered = orderRows.length > 0 && orderRows.every(row => {
                        const statusValue = typeof row.status === 'string' ? row.status : (row.status && row.status.value)
                        return statusValue === '20_DELIVERED'
                    })
                    const anyDelivered = orderRows.some(row => {
                        const statusValue = typeof row.status === 'string' ? row.status : (row.status && row.status.value)
                        return statusValue === '20_DELIVERED'
                    })

                    let nextStatus = null
                    if (allDelivered) {
                        nextStatus = { value: '10_COMPLETED', label: '10_COMPLETED' }
                    }
                    else if (anyDelivered) {
                        nextStatus = { value: '15_PARTIAL_DELIVERED', label: '15_PARTIAL_DELIVERED' }
                    }

                    if (nextStatus !== null) {
                        const updateOrder = await DataManager.updateItem('customer_order', { status: nextStatus }, customerOrder.id)
                        if (updateOrder.success !== 1) {
                            throw new Error(updateOrder.message || 'Impossibile aggiornare lo stato dell\'ordine cliente.')
                        }
                    }
                }
            }

            Swal.fire({ title: 'Completato', text: 'Consegnato con successo!', icon: 'success', confirmButtonColor: '#198754' })
            refreshData()
        }
        catch (error) {
            Swal.fire({ title: 'Errore', text: error.message || 'Impossibile completare la consegna.', icon: 'error', confirmButtonColor: '#dc3545' })
        }

    }


    if (entity !== null) {
        return (
            <>
                {item.status.value === "10_CREATED" ? (
                    <Button size="sm" variant='outline-primary' onClick={() => delivered()}>Consegnato</Button>
                ) : null}
                {item.status.value !== "0_PENDING" ? (
                    <Button size='sm' variant='outline-secondary' onClick={() => ddtCustomerOrder(item)} className='ms-1'><FontAwesomeIcon icon={'print'}></FontAwesomeIcon></Button>
                ) : null}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};
